function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import classnames from 'classnames';
import React from 'react';
import { FormGroup as RSFormGroup } from 'reactstrap';

var FormGroup = function FormGroup(props) {
  var className = 'form-group';

  if (props.className) {
    // Need form-group for property tests compatibility
    className = classnames(props.className, 'form-group');
  }

  return /*#__PURE__*/React.createElement(RSFormGroup, _extends({}, props, {
    className: className
  }));
};

FormGroup.displayName = "FormGroup";
export default FormGroup;